import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const ADMIN_TOKEN_KEY = "wt_admin_token";

export const getAdminToken = () =>
  typeof window !== "undefined" ? window.localStorage.getItem(ADMIN_TOKEN_KEY) : null;

export const setAdminToken = (token) => {
  if (typeof window !== "undefined") window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const clearAdminToken = () => {
  if (typeof window !== "undefined") window.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const adminHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
